"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const DragAndDrop = createSVGIcon(
  <g clipPath="url(#clip0)">
    <path fill="#fff" d="M0 0H24V24H0z" />
    <path
      d="M8.577 18H6.5a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2H16a2 2 0 0 1 2 2v2.077"
      stroke="currentColor"
      strokeLinecap="round"
      strokeDasharray="2 3"
    />
    <rect
      x="7.5"
      y="7.5"
      width="13"
      height="13"
      rx="1.5"
      fill="#fff"
      stroke="currentColor"
    />
  </g>,
  "DragAndDrop",
  {
    viewBox: "0 0 24 24",
    titleAccess: "DragAndDrop",
    fill: "none",
    height: "24px",
    width: "24px",
    className: legacyIconCls(),
  }
);
